const getOrganicProductCount = (productIdCollection, ABTestConfig) => {
  if (!productIdCollection) return undefined;

  const {
    json_variable: { advertPositions },
  } = ABTestConfig;
  return productIdCollection.length - advertPositions.length;
};

export default getOrganicProductCount;
